export default {
      id: "resize-usage",
      viewBox: "0 0 38 38",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#resize",
      toString: function () {
        return this.url;
      }
    }